export default {
  useMoreAddress: 'Usa un altro indirizzo',
  hideAddress: 'Nascondi indirizzo',
  productInventory: 'Elenco merci',
  tag: 'Etichetta',
  retainTag: 'Etichetta riservata',
  delTag: 'Elimina etichetta',
  externalPack: 'Imballaggio esterno',
  packDetail: 'Dettagli imballaggio',
  postLine: 'Linea di spedizione',
  selectLine: 'Seleziona la linea',
  editLine: 'Modifica la linea',
  service: 'Servizio',
  cancelServe: 'Annulla servizio',
  previewPackage: 'Anteprima pacco',
  postCountry: 'Paese di spedizione',
  packageNo: 'N. pacco',
  deliver: 'Spedire a',
  packageDetail: 'Dettagli pacco',
  addressInfo: "Informazioni sull'indirizzo",
  voWeight: 'Peso volumetrico',
  firstWeight: 'Primo peso',
  continueWeight: 'Peso aggiuntivo',
  actWeight: 'Peso effettivo',
  packageStatus: 'Stato del pacco',
  freightDetail: 'Informazioni sui costi',
  declareCurrency: 'Valuta di dichiarazione',
  selfDeclare: 'Dichiarazione autonoma',
  packageDeclarePrice: 'Importo totale dichiarato del pacco',
  youPackageProduct: 'Le merci nel tuo pacco',
  editYourDeclare: 'Modifica le tue informazioni di dichiarazione',
  startDeclare: 'Inizia la dichiarazione',
  declareType: 'Tipo di dichiarazione',
  productNo: 'ID prodotto',
  declareProductPrice: 'Prezzo unitario dichiarato',
  declareTotalPrice: 'Importo totale delle merci dichiarate',
  editDeclare: 'Modifica dichiarazione',
  declareLinePriceHint:
    "L'importo totale dichiarato più basso per la linea attuale: {min}, il più alto: {max}",
  classMaxNumHint: 'Il numero di categorie uniche ha raggiunto il limite massimo {max}',
  addDeclareProduct: 'Aggiungi merci dichiarate',
  plsConfirmInfo: 'Conferma le informazioni',
  wipePackProduct: 'Merci non imballate',
  foldPackProduct: 'Merci pieghevoli',
  wipeTagProduct: 'Merci senza etichetta',
  aboutCalcWeightExplain:
    "Poiché il pacco non è attualmente imballato, non conosciamo il peso effettivo del pacco in questa fase, quindi possiamo solo fare affidamento su diversi parametri esistenti per stimare il peso del pacco, al fine di riscuotere l'acconto. Una volta che il pacco sarà imballato e il peso effettivo ottenuto, l'eccedenza e la carenza saranno rimborsate.",
  expressInfo: 'Informazioni logistiche',
  deliveryMode: 'Modalità di consegna',
  targetCountry: 'Paese di destinazione',
  cancelPackage: 'Annulla pacco',
  cancelPackageHint:
    "Confermare l'annullamento di questo pacco? Non potrai recuperarlo dopo l'annullamento.",
  isDelPackage: "Confermare l'eliminazione definitiva del pacco?",
  delPackageHint:
    "Dopo l'eliminazione definitiva, non potrai più visualizzare il pacco, sii cauto!",
  receivedTips: 'Il tuo pacco è stato ricevuto, benvenuto di nuovo',
  packageQuestion: "C'è un problema con la consegna del pacco, puoi",
  afterSale: 'Richiedere assistenza post-vendita',
  repair: 'Rimborso',
  ucan: 'Puoi',
  clickAdd: 'Clicca su Aggiungi',
  addCategoryTips: "Non c'è un nome di prodotto che desideri dichiarare",
  noCarrierLines: 'Nessun percorso di spedizione disponibile',
  confirmPackageTitle: 'Hai confermato la ricezione della merce?',
  confirmPackageTips:
    'Per proteggere i tuoi diritti post-vendita, conferma la ricezione dopo aver verificato che il pacco sia corretto',
  receiptSuccess: 'Ricezione avvenuta con successo',
  position: 'Posizione',
  time: 'Ora',
  duty: 'Numero di partita IVA',
  inputTrueDuty: 'Inserisci il numero di partita IVA corretto',
  serveStatusEnum: {
    1: 'Foto personalizzate',
    2: 'Prolunga il periodo di stoccaggio',
    5: ' Video personalizzato',
  },
  inputCareTime: 'Seleziona la durata di stoccaggio',
  holder: {
    noInputSearch: 'N. pacco/N. prodotto',
    inputEditDeclareInfo: 'Modifica le tue informazioni di dichiarazione',
    packageRemark: 'Se hai altri requisiti speciali per il pacco, annotali qui',
    yourPriceSummary: 'Il tuo riepilogo dei prezzi',
  },
  calcFee: 'Costi stimati',
  realFee: 'Costi effettivi',
  declare: {
    repeatDeclare: 'Tipo di dichiarazione duplicato',
    addDeclareType: 'Aggiungi il tipo di dichiarazione',
  },
  feeEnum: {
    totalAmount: 'Acconto stimato',
    deposit: 'Costo stimato',
    overLongFee: 'Costo per eccessiva lunghezza',
    overWeightFee: 'Costo per eccessivo peso',
    remoteFee: 'Costo per zona remota',
    feeCustoms: 'Costo di gestione logistica',
    feeFuel: 'Supplemento carburante',
    feeOperation: 'Costo operativo',
    feeService: 'Costo del servizio',
    valueAddedTax: 'Imposta sul valore aggiunto',
    insuranceService: 'Premio assicurativo',
    incrementAmount: 'Costo del servizio a valore aggiunto',
    lineDiscount: 'Sconto sulla linea',
    discount: 'Sconti VIP',
    coupon: 'Seleziona un coupon',
    passwordDiscount: 'Password preferenziale',
    orderPreDiscount: 'Sconto sulla merce',
    insuranceDiscount: 'Sconto assicurativo',
    incrementDiscount: 'Offerta servizio a valore aggiunto',
    preVolumeCal: 'Pesatura stimata',
    actDeposit: 'Trasporto dopo la pesatura',
    actDepositAmount: 'Pagamento finale',
  },
  ratePaymentEnum: {
    name: "Modalità di pagamento dell'imposta",
    0: 'Pagato dal destinatario',
    1: 'IVA/GST della piattaforma',
    2: 'IVA/GST personale',
    3: 'IOSS della piattaforma',
    4: 'IOSS personale',
    5: 'IVA/GST aziendale',
    6: 'IVA/GST dei fornitori di logistica',
    7: 'IOSS dei fornitori di logistica',
    8: 'Esente da imposte',
  },
  bagStatusEnum: {
    0: 'Pacco normale',
    1: 'Reso nazionale',
    2: 'Reso internazionale',
    3: 'Annullato',
    4: 'In attesa di ricarica',
  },
  packageStatusEnum: {
    0: 'In attesa di elaborazione',
    1: 'In fase di elaborazione',
    2: 'In fase di ritiro',
    3: 'Ritirato',
    4: 'Imballaggio completato',
    5: 'Pesato',
    6: 'Lettera di vettura stampata',
    7: 'Scansionato',
    8: 'Consegnato al corriere',
    9: 'Spedito',
    20: 'Ricevuto',
  },
  declareEnum: {
    name: 'Metodo di dichiarazione',
    0: 'Dichiarazione di sistema',
    1: 'Dichiarazione personale',
  },
  backText: 'Indietro',
  packageInformation: 'Informazioni sul pacco',
  parcelNumber: 'N. pacco',
  noValidRule: "L'importo dichiarato non rispetta le regole: {rule}",
  shippingAgree: 'Accordo di spedizione pacchi acbuy',
  haveDiscountCode: 'Ho un codice sconto',
  inputDiscountCode: 'Inserisci qui il tuo codice sconto',
  expressNo: 'Numero di tracciamento',
  shipping: 'Spedizione',
  taxation: 'Tassazione',
  acCare: 'Ac Care',
  discountCode: 'Codice sconto',
  coupon: 'Coupon',
  rangeDeclare: "L'importo totale dichiarato supera il limite",
  noCouponData: 'Nessun coupon corrisponde alle condizioni di sconto sulla spedizione.',
  exchange: 'Cambio',
  'i18n-000001': 'Materiale',
  'i18n-000002': 'Colore',
  'i18n-000003': 'Modello/Taglia',
  'i18n-000004': 'Materiale',
  'i18n-000005': 'Dichiarare o meno',
  'i18n-000006': 'Promemoria amichevole',
  'i18n-000007':
    'Una volta inviate, Acbuy non modificherà le informazioni di dichiarazione. In caso di fallimento del pre-sdoganamento, procederemo comunque con la spedizione.',
  'i18n-000008':
    '1. In conformità con i requisiti della dogana brasiliana, si prega di dichiarare in dettaglio nome, materiale, colore, modello/taglia e il nome totale della dichiarazione non deve superare 5;',
  'i18n-000009':
    "2. Poiché i piccoli pacchi provenienti dal Brasile sono destinati all'uso personale, più pacchi che arrivano contemporaneamente alla dogana verranno trattenuti. Si prega di ritirare più articoli separatamente;",
  'i18n-000010':
    '3. Si raccomanda che un singolo pacco non superi i 4 kg e che ogni merce sia dichiarata ad almeno 3 USD. Per i prodotti di alto valore (console di gioco, telefoni cellulari, tablet, computer, ecc.), si prega di dichiararli onestamente per evitare il sequestro doganale;',
  'i18n-000011':
    '4. Standard fiscale locale in Brasile: 17% di ICMS + 20% di dazi doganali sono applicati per dichiarazioni inferiori a $50 e 17% di ICMS + 60% di dazi doganali sono applicati per dichiarazioni superiori a $50.',
  'i18n-000012':
    "5. Si prega di prestare attenzione a SMS ed e-mail dopo l'arrivo del pacco in Brasile e pagare le tasse in tempo",
  'i18n-000013': '{num} articoli',
  'i18n-000014': 'Nome del prodotto',
  cartonWarning:
    'Il tuo pacco è troppo grande per dimensioni o peso. Ti suggeriamo di utilizzare una scatola di cartone per ottenere una migliore compressione e ridurre il rischio di danni durante la spedizione',
  'i18n-0000003': 'Numero del pacco',
  'i18n-0000004': 'Ora di invio',
  'i18n-0000005': 'Volume stimato',
  'i18n-0000006': 'Peso stimato',
  'i18n-0000007': 'Costo stimato',
  'i18n-0000009': 'Metodo di spedizione',
  'i18n-0000010': 'Numero di tracciamento',
  'i18n-0000011': 'In attesa di pagamento',
  'i18n-0000017': 'Sconto coupon',
  'i18n-0000018': 'Indirizzo di spedizione',
  'i18n-0000019': 'Informazioni sulla dichiarazione',
  'i18n-0000020': 'Nome della dichiarazione del prodotto',
  'i18n-0000021': 'Importo dichiarato ($)',
  'i18n-0000022': 'Quantità',
  'i18n-0000023': 'Subtotale ($)',
  'i18n-0000024': 'Importo totale dichiarato',
  'i18n-0000025': 'Informazioni sul prodotto',
  'i18n-0000026': 'Prodotto',
  'i18n-0000027': 'Peso (g)',
  'i18n-0000028': 'Volume (cm³)',
  'i18n-0000029': "Dettagli dell'imballaggio",
  'i18n-0000033': 'Rimborso in attesa',
  'i18n-0000034': 'In attesa di pagamento aggiuntivo',
  'i18n-0000035': 'Volume effettivo',
  'i18n-0000036': 'Peso fatturabile',
  'i18n-0000037': 'Costo effettivo',
  'i18n-0000038': 'Pagamento effettivo',
  'i18n-0000039': 'Foto del pacco',
  'i18n-0000040': 'Scarica la fattura del pacco',
  'i18n-0000041': 'Rimborsato sul saldo del portafoglio',
  'i18n-0000042': 'Rimb.',
  'i18n-0000043': 'Pagamento aggiuntivo effettuato',
  'i18n-0000046': 'Espandi',
  'i18n-0000047': 'Riduci',
  'i18n-0000048': 'Tracciamento logistico',
  'i18n-0000049': 'Informazioni sulla pesatura',
  'i18n-0000050': 'Rimborsato',
  'i18n-0000051': 'Previsto nel Portafoglio entro 72 ore',
  samePreviewTips: 'Questo pacco di prova è già stato inviato. Vuoi inviarlo di nuovo?',
  confirmSubmitTitle: 'Conferma e continua',
  confirmSubmitText: 'Si prega di confermare l’indirizzo di spedizione:',
  confirmSubmitContent: `Indirizzo di spedizione: {address}

Avviso importante: Il peso addebitabile mostrato è un valore stimato. Il peso finale verrà determinato in base al peso effettivo misurato dopo l’imballaggio, solitamente calcolato considerando il maggiore tra il peso volumetrico e quello reale. Se vi sono differenze tra l’importo stimato e quello finale, verrà applicata la regola del “rimborso o integrazione”.`,
}
